module.exports = __webpack_public_path__ + "static/media/IMG_4297.7f87ba56.PNG";